<template>
  <div class="CoalModel_box">
    <div v-if="!compContent">
      <div class="CoalModel_box_title">
        <div class="CoalModel_box_title_desc">煤矿管理</div>
      </div>
      <el-divider></el-divider>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline" ref="form" size="small">
        <el-form-item label>
          <el-input
            v-model="filterForm.companyName"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.userName"
            placeholder="请输入用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.contactPhone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select v-model="filterForm.status" placeholder="状态" filterable clearable>
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="getData(true)"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button icon="fa fa-share" label="重置" perms="-1" @click="getReset" type="primary" />
        </el-form-item>
      </el-form>
      <el-table v-loading="loading" :data="tableData" stripe size="mini" style="width: 100%">
        <el-table-column type="index" align="center" fixed label="序号"></el-table-column>
        <el-table-column prop="coalMineNo" align="center" label="编号"></el-table-column>
        <el-table-column align="center" prop="companyName" label="公司名称"></el-table-column>
        <el-table-column prop="userName" align="center" label="用户名"></el-table-column>
        <el-table-column align="center" prop="contactPhone" label="联系电话"></el-table-column>
        <el-table-column prop="companyAddress" align="center" min-width="200" label="地址"></el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            {{
            scope.row.status == 0
            ? "启用"
            : scope.row.status == 1
            ? "停用"
            : scope.row.status == 2
            ? "待审核"
            : "驳回"
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" align="left" fixed="right">
          <!-- 2,待审核 0,审核成功,3驳回 -->
          <!-- ENABLE(0, "启用"),
          DISABLE(1, "停用"),
          PENDING_APPROVAL(2, "待审核"),
          REJECT(3, "驳回"),
          -->
          <template slot-scope="scope">
            <kt-button label="查看" perms="-1" icon="fa fa-edit" @click="showDetail(scope.row)" />
            <kt-button
              label="审核"
              icon="fa fa-edit"
              perms="-1"
              v-if="+scope.row.status == 2"
              @click="handleClick(scope.row)"
              type="primary"
            />
            <kt-button
              label="启用"
              icon="fa fa-check"
              perms="30200"
              @click="getEnable(scope.row)"
              v-if="+scope.row.status == 1"
              type="primary"
            />
            <kt-button
              label="停用"
              icon="fa fa-remove"
              perms="30200"
              type="danger"
              @click="getOutService(scope.row)"
              v-if="+scope.row.status == 0"
            />
            <kt-button
              label="启用派单"
              icon="el-icon-switch-button"
              perms="-1"
              @click="handleCanDispatchOrder(scope.row)"
              v-if="+scope.row.status == 0 && +scope.row.canDispatchOrder == 1"
              type="primary"
            />
            <kt-button
              label="停止派单"
              icon="el-icon-switch-button"
              perms="-1"
              type="danger"
              @click="handleDisableDispatchOrder(scope.row)"
              v-if="+scope.row.status == 0 && +scope.row.canDispatchOrder == 0"
            />
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="form.pageNo"
          :page-size="form.pageSize"
          :total="totalSize"
          style="float: right"
        ></el-pagination>
      </div>
    </div>
    <!--调整历史-->
    <component
      :is="compContent"
      @Adjust="AdjustFun"
      @checkDetail="getAdjust"
      :coalMineNo="coalCategoryNo"
    ></component>

    <!--操作影响弹窗-->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="30%" center>
      <div class="dia-audit">
        <div>用户名：{{ checkTableItem.userName }}</div>
        <div>公司名称：{{ checkTableItem.companyName }}</div>
        <!-- <div>简称：{{ checkTableItem.companyShortName }}</div> -->
        <div>地址:{{ checkTableItem.companyAddress }}</div>
        <div>联系电话：{{ checkTableItem.contactPhone }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditCar(0)">审核通过</el-button>
        <el-button type="primary" @click="auditCar(1)">审核驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";
import AdjustHistory from "./AdjustHistory";
import CollieryDetail from "./CollieryDetail";

export default {
  components: {
    KtButton
  },
  data() {
    return {
      companyNames: [],
      contactPhones: [],
      userNames: [],
      compContent: "",
      size: "small",
      loading: false,
      dialogVisible: false,
      form: {
        pageNo: 1,
        pageSize: 10
      },
      filterForm: {
        status: null,
        companyName: "",
        userName: "",
        contactPhone: ""
      },
      coalTypeList: [],
      stateList: [
        {
          label: "启用",
          value: "0"
        },
        {
          label: "停用",
          value: "1"
        },
        {
          label: "待审核",
          value: "2"
        },
        {
          label: "驳回",
          value: "3"
        }
      ],
      tableData: [],
      checkTableItem: {}, //选中列
      totalSize: 0,
      coalCategoryNo: "" // 煤种编号
    };
  },
  mounted() {
    const _t = this;
    _t.getSelect();
    _t.getData(true);
  },
  methods: {
    // 请求数据
    getData(val) {
      const _t = this;
      if (val) {
        _t.form.pageNo = 1;
      }
      _t.loading = true;
      let params = {
        ...this.form
      };
      console.log("tag", params);
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          params["searchFieldList[" + index + "].singleValue"] = val;
          index++;
        }
      }
      _t.$api.coalModel.coalmineList(params).then(res => {
        if (res.code === "0") {
          _t.tableData = res.data.dtoList;
          _t.totalSize = res.data.totalSize;
          _t.loading = false;
        } else {
          _t.loading = false;
          _t.$message({
            message: "查询失败, " + res.message,
            type: "error"
          });
        }
      });
    },
    //下拉框
    async getSelect() {
      const _t = this;
      let companyNames = await _t.$api.coalModel.getCompanyNames();
      let contactPhones = await _t.$api.coalModel.getContactPhones();
      let userNames = await _t.$api.coalModel.getUserNames();
      _t.companyNames = companyNames.data;
      _t.contactPhones = contactPhones.data;
      _t.userNames = userNames.data;
    },
    //审核
    async auditCar(type) {
      const _t = this;
      let data = await _t.$api.coalModel.coalmineApproval({
        coalMineNo: this.checkTableItem.coalMineNo,
        approvalResult: type
      });
      if (+data.code == 0) {
        _t.getData(true);
        _t.dialogVisible = false;
      }
    },
    // // 校验重复
    // checkContract(callback) {
    //   const _t = this
    //   const form = {
    //     name: _t.ruleForm.coalCategoryName
    //   }
    //   _t.$api.coalModel.getIsRepeatName(form).then((res) => {
    //     if (res.code === '0') {
    //       if (res.data) {
    //         callback(new Error('煤种名称重复'))
    //       } else {
    //         callback()
    //       }
    //     }
    //   })
    // },
    // // 重置
    getReset() {
      const _t = this;
      (_t.filterForm = {
        status: null,
        companyName: "",
        userName: "",
        contactPhone: ""
      }),
        _t.getData(true);
    },
    handleClick(row) {
      const _t = this;
      _t.title = "审核";
      _t.dialogVisible = true;
      _t.checkTableItem = row;
      console.log(row);
    },
    // 启用
    getEnable(val) {
      const _t = this;
      const form = {
        coalMineNo: val.coalMineNo
      };
      _t.$confirm("是否确认启用该煤矿?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          _t.$api.coalModel.getEnable(form).then(res => {
            if (res.code === "0") {
              _t.$message({
                message: "启用成功!",
                type: "success"
              });
              _t.getData(true);
            }
          });
        })
        .catch(() => {});
    },
    // 停用
    getOutService(val) {
      const _t = this;
      const form = {
        coalMineNo: val.coalMineNo
      };
      _t.$confirm("是否确认停用该煤矿?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          _t.$api.coalModel.getDisable(form).then(res => {
            if (res.code === "0") {
              _t.$message({
                message: "停用成功!",
                type: "success"
              });
              _t.getData(true);
            }
          });
        })
        .catch(() => {});
    },

    // 启用派单
    handleCanDispatchOrder(val) {
      const _t = this;
      _t.$confirm("是否启用该煤矿派单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          _t.$api.coalModel.mEnableDispatchOrder({
          coalMineNo: val.coalMineNo
        })
        .then(res => {
          if (res.code === "0") {
            _t.$message({
              message: "已启用派单",
              type: "success"
            });
            _t.getData(true);
          }
        });
      })
      .catch(() => {});
    },
    // 禁止派单
    handleDisableDispatchOrder(val) {
      const _t = this;
      _t.$confirm("是否停止该煤矿派单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          _t.$api.coalModel.mDisableDispatchOrder({
          coalMineNo: val.coalMineNo
        }).then(res => {
          if (res.code === "0") {
            _t.$message({
              message: "已停止派单",
              type: "success"
            });
            _t.getData(true);
          }
        });
      })
      .catch(() => {});
    },

    // 点击调整历史
    getAdjust(val) {
      this.compContent = () => import("./AdjustHistory");
    },
    //点击查看详情
    showDetail(val) {
      this.coalCategoryNo = val.coalMineNo;
      this.compContent = () => import("./CollieryDetail");
    },
    // 接受调整历史子组件传回的值
    AdjustFun(val) {
      this.compContent = "";
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.form.pageNo = pageNo;
      this.getData(false);
    }
  }
};
</script>
<style lang="scss">
.dia-audit {
  div {
    margin-bottom: 5px;
  }
}
.CoalModel_box {
  box-sizing: border-box;
  padding: 10px;
  .CoalModel_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalModel_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalModel_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .CoalModel_box_dialog {
    display: flex;
    justify-content: space-around;

    .CoalModel_box_dialog_nr {
      width: 33%;

      div:first-child {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }

  .CoalModel_box_dialog_nr_ts {
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
    font-size: 16px;
  }
}
</style>
